import { keepPreviousData, useQuery } from '@tanstack/react-query'

import type { GetAirportsBySearchParamResponse } from '../../types/index.js'

import { apiClient } from '../../lib/client.js'
import { airportKeys } from './keys.js'

/** Le référentiel d'aéroports ne bouge pas d'une frappe à l'autre. */
const FIVE_MINUTES_IN_MS = 5 * 60 * 1000

export const useGetAirportsBySearchParamQuery = ({
  enabled = true,
  searchParam,
}: {
  enabled?: boolean
  searchParam: string
}) =>
  useQuery({
    enabled,
    // Garde les résultats précédents affichés pendant qu'on interroge le terme
    // suivant : sans ça la liste se vide entre deux frappes dès que la latence
    // dépasse le debounce (mobile, 4G) — invisible en local, pas en production.
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const response = await apiClient.client.get<GetAirportsBySearchParamResponse>(
        `/airport/search/${searchParam}`
      )
      return response.data
    },
    queryKey: airportKeys.bySearchParam(searchParam),
    staleTime: FIVE_MINUTES_IN_MS,
  })
